const Revert = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2 5.99967H11C12.6569 5.99967 14 7.34282 14 8.99967C14 10.6565 12.6569 11.9997 11 11.9997H8M2 5.99967L4.66667 3.33301M2 5.99967L4.66667 8.66634"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Revert;
